<template>
    <div>
        <confirm-dialog @confirmed="change">
            <button-secondary @click="open"><i class="fa fa-exchange"></i></button-secondary>
            <template v-slot:header>Buchung ändern</template>
            <template v-slot:question>
                <span > Soll die Buchung am <span class="font-bold">{{ booking.start | date }}</span> wirklich geändert werden?</span>

                <date-time-range-select v-model="range"
                                        time-selection-mode="free"
                                        :has-repeating="true"
                ></date-time-range-select>

                <div class="mb-4 col-span-12" v-if="floors">
                    <select-menu
                        class="mb-4 col-span-12 sm:col-span-6"
                        v-model="floor"
                        :values="[null,...floors.map(g => g.id)]"
                        :text="['Ohne Etage',...floors.map(g => g.name)]">
                        Etage
                    </select-menu>
                </div>

                <div class="mb-4 col-span-12">
                    <conference-room-navigation v-if="floor" v-model="selectedIds" :items="rooms" :unavailable="unavailable" @toggle="selectRoom"></conference-room-navigation>
                </div>

                <div v-if="selectedRoom" class="mb-4 col-span-12 sm:col-span-6">
                    <div class="text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">Raum</div>
                    <div>
                        <a @click="selectedRoom = null"
                           class="cursor-pointer inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-office-primary text-white"
                        >
                            {{ selectedRoom.name }}
                            <button type="button"
                                    class="flex-shrink-0 ml-1.5 inline-flex text-white focus:outline-none focus:text-white"
                                    aria-label="">
                                <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                                    <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
                                </svg>
                            </button>
                        </a>
                    </div>

                    <div>
                        <room-layout-select
                            class="mb-8"
                            :items="selectedRoom.room_layouts"
                            v-model="roomLayout"
                        ></room-layout-select>

                        <multi-select-small
                            class="mb-8"
                            v-show="selectedRoom.postable_equipment.length > 0"
                            :text="selectedRoom.postable_equipment.map(e => e.name)"
                            :values="selectedRoom.postable_equipment.map(e => e.id)"
                            :quantity="selectedRoom.postable_equipment.map(e => e.quantity)"
                            v-model="postableEquipment">Zubuchbares Equipment
                        </multi-select-small>

                        <catering-select
                            class="mb-8"
                            :items="selectedRoom.caterings"
                            v-model="caterings"
                        ></catering-select>

                        <conference-room-event-details-input :room="selectedRoom" v-model="confRoomEvent"></conference-room-event-details-input>

                        <input-text
                            class="mb-2"
                            v-model="comment"
                        >
                            {{ $t('bookings.note') }}
                        </input-text>

                    </div>
                </div>

                <div>
                    <div v-show="page === 'overview'">
                        <loading v-show="loading"></loading>
                        <tailwind-table v-show="rooms.length > 0 " class="mt-8" :header="['Raum', 'Personen', '']">
                            <tr v-for="(room, i) in rooms" :class="{'bg-gray-50': i % 2}">
                                <td class="px-6 py-3">{{ room.name }}</td>
                                <td class="px-6 py-3"><i class="fa fa-users mr-2"></i>{{ room.persons }}</td>
                                <td class="px-6 py-3 text-right">
                                    <button-white @click="selectRoom(room.id)">Auswählen</button-white>
                                </td>
                            </tr>
                        </tailwind-table>
                        <p v-show="rooms.length === 0 && !loading">Keine buchbaren Räume gefunden.</p>
                    </div>
                </div>

            </template>
            <template v-slot:confirm>
                Buchung ändern
            </template>
        </confirm-dialog>
    </div>
</template>

<script>
import Modal from "./Modal";
import ButtonSecondary from "./UI/ButtonSecondary";
import ButtonPrimary from "./UI/ButtonPrimary";
import InputText from "./UI/InputText";
import SelectMenu from "./UI/SelectMenu";
import TailwindTable from "./UI/TailwindTable";
import ButtonWhite from "./UI/ButtonWhite";
import Loading from "./UI/Loading";
import MultiSelect from "./UI/MultiSelect.vue";
import MultiSelectSmall from "./UI/MultiSelectSmall.vue";
import RoomLayoutSelect from "./RoomLayoutSelect.vue";
import CateringSelect from "./CateringSelect.vue";
import NavigationFloor from "./NavigationFloor.vue";
import ConferenceRoomNavigation from "./ConferenceRoomNavigation.vue";
import TRichSelect from "vue-tailwind/dist/t-rich-select";
import ConferenceRoomEventDetailsInput from "./ConferenceRoomEventDetailsInput.vue";
import ConfirmDialog from "./UI/ConfirmDialog.vue";
import ButtonDelete from "./UI/ButtonDelete.vue";
import DateTimeRangeSelect from "./DateTimeRangeSelect.vue";

export default {
    name: "ConferenceRoomBookingEdit",

    components: {
        DateTimeRangeSelect,
        ButtonDelete, ConfirmDialog,
        ConferenceRoomEventDetailsInput,
        TRichSelect,
        ConferenceRoomNavigation,
        NavigationFloor,
        CateringSelect,
        RoomLayoutSelect,
        MultiSelectSmall,
        MultiSelect,
        Loading,
        ButtonWhite,
        TailwindTable,
        SelectMenu,
        InputText,
        ButtonPrimary,
        ButtonSecondary,
        Modal,
    },

    inject: ['group'],

    props: {
        booking: {},
        floors: {},
    },

    data: () => ({
        confRoomEvent: {
            title: null,
            phone: null,
            supervisor: null,
            person: null,
            description: null,
        },

        floor: null,
        showModal: false,
        loading: false,
        date: null,
        comment: '',
        rooms: [],
        selectedRoom: null,
        postableEquipment: [],
        roomLayout: null,
        caterings: [],
        unavailable: [],
        selectedIds: [],
        user: null,
        range: {
            start: (new Date()).toISOString().substring(0, 10) + ' 06:00',
            end: (new Date()).toISOString().substring(0, 10) + ' 07:00',
        },
    }),

    mounted() {
        // this.open()
    },

    filters: {
        date(val) {
            let [date, time] = val.split(' ');
            let [y, m, d] = date.split('-');
            return `${d}.${m}.${y}`;
        }
    },

    watch: {
        selectedRoom(){
            if(this.selectedRoom){
                if(this.selectedRoom.caterings.length === 0){
                    this.caterings = [];
                }

                if(this.selectedRoom.room_layouts.length === 0){
                    this.roomLayout = null;
                }

                if(this.selectedRoom.postable_equipment.length === 0){
                    this.postableEquipment = [];
                }
            }
        },
        floor(){
            this.search()
        },
        range: {
            deep: true,
            handler() {
                this.search(this.selectedRoom);
            },
        }
    },

    computed: {
        page() {
            if (this.selectedRoom) {
                return 'confirm';
            }

            return 'overview';
        },
        start() {
            return this.range.start;
        },
        end() {
            return this.range.end;
        },
    },

    methods: {
        open() {
            this.roomLayout = this.booking.room_layout?.id;
            this.postableEquipment = this.booking.postable_equipment.map((p) => p.id)
            this.caterings = this.booking.caterings.map((p) => p.id)
            this.confRoomEvent = {
                title: this.booking.event?.title,
                phone: this.booking.event?.phone,
                supervisor: this.booking.event?.supervisor,
                person: this.booking.event?.person,
                description: this.booking.event?.description,
            }
            this.comment = this.booking.comment;

            this.selectedRoom = this.booking.conference_room

            let series = {};
            if(this.booking.conference_room_booking_series){
                series = {
                    isSeries : true,
                    every: this.booking.conference_room_booking_series.cycle,
                    until: this.booking.conference_room_booking_series.end,
                    repeat: this.booking.conference_room_booking_series.type,
                }
            }

            this.range = {
                end: this.booking.end.substring(0, 16),
                start: this.booking.start.substring(0, 16),
                ... series
            }
        },

        search(cr = null) {
            this.loading = true;
            this.rooms = [];

            let [y, m, d] = this.range.start.substring(0, 10).split('-');
            this.date = `${y}-${m}-${d}`;

            let params = {
                start: this.start,
                end: this.end
            }

            if (this.range.isSeries) {
                params.repeat = this.range.repeat;
                params.every = this.range.every;
                params.until = this.range.until;

                if(this.range.error){
                    this.loading = false;
                    return;
                }
            }

            if(this.floor){
                params["floor_id"] = this.floor;
            }

            params.conference_room_booking_id = this.booking.id

            window.axios.get(`/admin/conference_room_bookings`,{params})
                .then(response => {
                    this.loading = false;
                    this.rooms = response.data.data;
                    this.rooms = Object.keys(this.rooms).map((key) => this.rooms[key]);
                    if(cr){
                        this.selectRoom(cr.id);
                    }
                    this.unavailable = response.data.unavailable;
                    this.unavailable = Object.keys(this.unavailable).map((key) => this.unavailable[key]);
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        selectRoom(id){
            if(!id){
                this.selectedIds = [];
                this.selectedRoom = null;
                return;
            }

            this.selectedIds = [id]
            this.selectedRoom = this.rooms.find(r=>r.id === id)

            if(this.selectedRoom){
                this.postableEquipment = this.postableEquipment.filter(equipment => this.selectedRoom.postable_equipment.map((v) => v.id).includes(equipment));
                this.caterings = this.caterings.filter(equipment => this.selectedRoom.caterings.map((v) => v.id).includes(equipment));
                this.roomLayout = this.selectedRoom.room_layouts.map((v) => v.id).includes(this.roomLayout) ? this.roomLayout : null;
            }
        },
        validateDates(){
            this.dateError = this.date >= this.until && this.isSeries;
        },

        change() {
            this.loading = true;

            let params = {
                start: this.start,
                end: this.end,
                event: this.confRoomEvent,
                comment: this.comment ?? '',
                switch: this.selectedRoom.id,
                postable_equipment: this.postableEquipment,
                room_layout: this.roomLayout,
                caterings: this.caterings,
                user_id: this.booking.user?.id,
                conference_room_booking_id: this.booking.id
            };

            if (this.range.isSeries) {
                if(this.booking.conference_room_booking_series){
                    params.series = this.booking.conference_room_booking_series.id
                }

                params.repeat = this.range.repeat;
                params.every = this.range.every;
                params.until = this.range.until;

                if(this.range.error){
                    this.loading = false;
                    return;
                }
            }

            this.$http
                .put(`/admin/conference_room_bookings/${this.booking.id}`, params)
                .then(() => {
                    this.$emit('changed');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
    }
}
</script>

<style scoped>

</style>
